import { render } from "./self-assessment-starting-page.vue?vue&type=template&id=7369f7b3&scoped=true&ts=true"
import script from "./self-assessment-starting-page.vue?vue&type=script&lang=ts"
export * from "./self-assessment-starting-page.vue?vue&type=script&lang=ts"

import "./self-assessment-starting-page.vue?vue&type=style&index=0&id=7369f7b3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7369f7b3"]])

export default __exports__